import type { ChatState } from './interfaces.chat';
import { chatHistoryReducer } from './state.chat-history';
import { chatSessionReducer } from './state.chat-session';
import { chatSessionManagerReducer } from './state.chat-session-manager';
import { generateEmptyChatState } from './state.initial-state';
import { settingsReducer } from './state.settings';

function baseChatReducer(state: ChatState.State, action: ChatState.Action): ChatState.State {

  const newState = computeNewState(state, action);

  logAction(state, newState, action);

  return newState;
}

function batchActions(state: ChatState.State, { payload }: ChatState.BatchAction): ChatState.State {

  let updatedState = state;
  for (const action of payload.actions) {
    updatedState = baseChatReducer(updatedState, action);
  }

  return updatedState;
}

export function chatReducer(state: ChatState.State, action: ChatState.Action): ChatState.State {
  switch (action.type) {

    case 'batch-actions':
      return batchActions(state, action);

    default:
      return baseChatReducer(state, action);
  }
}

function computeNewState(state: ChatState.State, action: ChatState.Action): ChatState.State {
  switch (action.type) {

    case 'reset-chat-state':
      return generateEmptyChatState({
        contextItems: state.contextItems,
        context: action.payload.context,
        settings: state.settings,
        features: state.settings,
        brandIdentifier: action.payload.brandIdentifier,
        landingCardsVisible: state.session.landingCardsVisible,
      });

    default: {
      const newState: ChatState.State = {
        contextItems: state.contextItems,
        settings: settingsReducer(state.settings, action),
        history: chatHistoryReducer(state.history, action),
        session: chatSessionReducer(state, action),
        sessionManager: chatSessionManagerReducer(state.sessionManager, action),
      };

      newState.history = {
        ...newState.history,
        tabs: syncSessionTab(state, newState),
      };

      return newState;
    }
  }
}

function syncSessionTab(prevState: ChatState.State, newState: ChatState.State): ChatState.State['history']['tabs'] {
  const tabs = newState.history.tabs;
  const sessionIdentifier = newState.session.chatInstance.identifier;

  if (tabs.items.includes(sessionIdentifier)) {
    return tabs;
  }

  const oldSessionIdentifier = prevState.session.chatInstance.identifier;
  const oldSessionInHistory =
    newState.history.items.some(item => item.identifier === oldSessionIdentifier) ||
    newState.history.shared.some(item => item.identifier === oldSessionIdentifier);

  if (!oldSessionInHistory && tabs.items.includes(oldSessionIdentifier)) {
    // Replace the unsaved tab with the new session's tab
    const oldIndex = tabs.items.indexOf(oldSessionIdentifier);
    const updatedItems = [...tabs.items];
    updatedItems[oldIndex] = sessionIdentifier;
    return {
      items: updatedItems,
      index: oldIndex,
    };
  }

  return {
    items: tabs.items.concat(sessionIdentifier),
    index: tabs.items.length,
  };
}

function logAction(oldState: ChatState.State, newState: ChatState.State, action: ChatState.Action) {
  // if (isDevEnv()) {
  //   console.groupCollapsed('Chat Action', action);
  //   console.log('Old State', oldState);
  //   console.log('New State', newState);
  //   console.groupEnd();
  // }
}
